// extracted by mini-css-extract-plugin
export default {"city":"city-module--city--ZwAyX"};